var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-contents.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"";
if(!runtime.contextOrFrameLookup(context, frame, "showProductDetails") && !runtime.contextOrFrameLookup(context, frame, "showShippingAndReturns")) {
output += "s-last-tab ";
;
}
output += "o-accordion__tabset js-accordion-tabset is-collapsed\" data-accordion-tab-name=\"contents\">\n\n    ";
output += "\n    <div class=\"o-row\">\n\n        <div class=\"o-column o-extra-small--12\">\n\n            <a href=\"#product_contents__panel\" id=\"product_contents__tab\" class=\"o-accordion__tab c-product-details__tab js-accordion-tab\" aria-selected=\"true\" aria-controls=\"product_contents__panel\" aria-expanded=\"false\" role=\"tab\" data-accordion-title=\"product contents\">\n\n                <h3 class=\"o-accordion__label c-product-details__label\" data-qa-details-accordion>\n                    ";
output += runtime.suppressValue((lineno = 10, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_details-contents",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                </h3>\n\n                <span class=\"o-accordion__control c-product-details__collapse\" title=\"collapse\"></span>\n\n            </a>\n\n        </div>\n\n    </div>\n\n    ";
output += "\n    <div id=\"product_contents__panel\" class=\" s-cms o-accordion__panel js-accordion-panel c-product-details__section c-product-details__section--pdp\" aria-labelledby=\"product_contents__tab\" aria-hidden=\"false\" role=\"tabpanel\">\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                <ul>\n                    ";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"contents");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("contentItem", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                        <li>";
output += runtime.suppressValue(t_4, env.opts.autoescape);
output += "</li>\n                    ";
;
}
}
frame = frame.pop();
output += "\n                </ul>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-contents.j2"] , dependencies)